<template>
  <el-form label-position="right" ref="form" :model="form.model" :rules="formRules" :validate-on-rule-change="false" label-width="120px">
    <el-row>
      <el-col :xs="24" :sm="24" :md="7" :lg="7">
        <el-form-item label="计费项" prop="billingConfigItemObject">
          <contract-config-item-select v-model="form.model.billingConfigItemObject" @change="handleContractConfigItemChange" value-key="id" :disabled="!editable" filterable clearable size="small">
          </contract-config-item-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('billingConfigItem')">
              (原：{{form.oldModel.billingConfigItemObject != null ? form.oldModel.billingConfigItemObject.billingItem : ''}})
        </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7">
        <el-form-item label="计费项名称" prop="name">
          <el-input v-model="form.model.name" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('name')">
              (原：{{form.oldModel.name}})
        </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="form.model.billingConfigItemObject != null">
        <el-form-item label="计费方式" prop="billingCategory">
          <dictionary-select :value="billingCategory" :disabled="true" :factory-name="'domain'" :params="'BILLINGCATEGORY'" clearable filterable size="small">
          </dictionary-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="form.model.billingConfigItemObject != null">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldConfigItemShow('billingCategory')">
              (原：
          <dictionary-text :value="oldBillingCategory" :factory-name="'domain'" :params="'BILLINGCATEGORY'" clearable filterable size="small">
          </dictionary-text>
          )
        </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="form.model.billingConfigItemObject != null">
        <el-form-item label="计量单位" prop="calculateUnit">
          <el-input :value="calculateUnit" :disabled="true" size="small">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="form.oldModel.billingConfigItemObject != null">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldConfigItemShow('calculateUnit')">
              (原：{{form.oldModel.billingConfigItemObject == null ? '' : form.oldModel.billingConfigItemObject.calculateUnit}})
        </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="form.model.billingConfigItemObject != null">
        <el-form-item label="计费周期" prop="billingCycle">
          <dictionary-select :value="billingCycle" :disabled="true" :factory-name="'domain'" :params="'BILLINGCYCLE'" clearable filterable size="small">
          </dictionary-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="form.model.billingConfigItemObject != null">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldConfigItemShow('billingCycle')">
              (原：<dictionary-text :value="oldBillingCycle" :factory-name="'domain'" :params="'BILLINGCYCLE'" clearable filterable size="small">
          </dictionary-text>)
        </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="form.model.billingConfigItemObject != null">
        <el-form-item label="计费对象" prop="billingObj">
          <dictionary-select :value="billingObj" :disabled="true" :factory-name="'domain'" :params="'BILLINGOBJ'" clearable filterable size="small">
          </dictionary-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="form.model.billingConfigItemObject != null">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldConfigItemShow('billingObj')">
              (原：<dictionary-text :value="oldBillingObj" :factory-name="'domain'" :params="'BILLINGOBJ'" clearable filterable size="small">
          </dictionary-text>)
        </span>
      </el-col>

      <!-- 起征点 -->
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="thresholdShow">
        <el-form-item :label="thresholdLabel" prop="threshold">
          <el-input-number v-model="form.model.threshold" :precision="2" :step="0.01" :disabled="!editable" size="small" class="width100">
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="thresholdShow">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('threshold')">
              (原：{{form.oldModel.threshold}})
        </span>
      </el-col>

      <!-- 限额 -->
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="quotaShow">
        <el-form-item :label="quotaLabel" prop="quota">
          <el-input-number v-model="form.model.quota" :precision="2" :step="0.01" :disabled="!editable" size="small" class="width100">
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="quotaShow">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('quota')">
              (原：{{form.oldModel.quota}})
        </span>
      </el-col>

      <!-- 费用、超额费用 -->
      <el-col :xs="24" :sm="24" :md="7" :lg="7" v-if="rateShow">
        <el-form-item :label="rateLabel" prop="rate">
          <el-input-number v-model="form.model.rate" :precision="2" :step="0.01" :disabled="!editable" size="small" class="width100">
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5" v-if="rateShow">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('rate')">
              (原：{{form.oldModel.rate}})
        </span>
      </el-col>

      <!-- 占位 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="thresholdShow && quotaShow && rateShow || !quotaShow && rateShow">
        <div class="el-form-item">
          <label class="el-form-item__label">
            &nbsp;&nbsp;
          </label>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="7" :lg="7">
        <el-form-item label="" prop="ifTest">
          <el-checkbox v-model="form.model.ifTest" :true-label="1" :false-label="0" :disabled="!editable" label="测试电计费专用条款" size="small">
          </el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('ifTest')">
              (原：{{form.oldModel.ifTest === 0 ? '未勾选' : form.oldModel.ifTest === 1 ? '勾选' : form.oldModel.ifTest}})
        </span>
      </el-col>

      <el-col :xs="24" :sm="24" :md="7" :lg="7">
        <el-form-item label="合约功率(kW)" prop="power">
          <el-input-number v-model="form.model.power" :disabled="!editable" :min="0" placeholder="单位(kW)" size="small" class="width100">
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('power')">
              (原：{{form.oldModel.power}})
        </span>
      </el-col>

      <el-col :xs="24" :sm="24" :md="7" :lg="7">
        <el-form-item label="开始日期" prop="beginDate">
          <el-date-picker v-model="form.model.beginDate" :disabled="!editable" placeholder="开始日期"
                          type="date" format="yyyy-MM-dd" value-format="timestamp" size="small">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('beginDate')">
              (原：{{form.oldModel.beginDate | formatDate}})
        </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7">
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker v-model="form.model.endDate" :disabled="!editable" placeholder="结束日期"
                          type="date" format="yyyy-MM-dd" value-format="timestamp" size="small">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="5" :lg="5">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data" v-show="getOldFormModelShow('endDate')">
              (原：{{form.oldModel.endDate | formatDate}})
        </span>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-form-item label="当天是否计费" prop="billCSBs">
          <div v-for="billCSB in form.model.billCSBs" :key="billCSB.code">
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-checkbox v-model="billCSB.value" :disabled="!editable">
                {{billCSB.name}}
              </el-checkbox>
            </el-col>
          </div>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" v-show="getOldFormModelShow('billCSBs')">
        <span>&nbsp;&nbsp;</span>
        <span class="old-data">
                (原：{{formatBillCSBs(form.oldModel.billCSBs)}})
              </span>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import _ from 'lodash'
  import {merge} from '@/util/common'
  import {handleError} from "@/util/error-util";
  import DictionarySelect from '@/components/common/DictionarySelect'
  import DictionaryText from '@/components/common/DictionaryText'
  import ContractConfigItemSelect from '@/components/billing/contract/contract.config.item.select'
  import BillingServer from '@/api/billing'
  import {formatDate} from "element-ui/src/utils/date-util";
  import {
    setContractItemBillCSBs, getBillCSBs,
    getContractItemColumns, columnValueEquals, parse, getColumnValue,
  } from "@/views/billing/contract/record/contract-record-common";

  let columns = getContractItemColumns();
  let columnsMap = _.keyBy(columns, 'name');

  export default {
    name: "ContractItemDetail",
    components: {DictionarySelect, DictionaryText, ContractConfigItemSelect},
    props: {
      contractFlag: {},
    },
    data() {
      return {
        operation: '',
        billCSBs: [],
        form: {
          model: {
            id: null,
            contractId: null,
            billingConfigItem: null,
            name: null,
            threshold: null,
            quota: null,
            ifTest: 0,
            power: null,
            beginDate: null,
            endDate: null,
            uuid: null,
            release: null,
            billCSBs: [],
            billCSBsMap: {},
          },
          oldModel: {
            id: null,
            contractId: null,
            billingConfigItem: null,
            name: null,
            threshold: null,
            quota: null,
            ifTest: 0,
            power: null,
            beginDate: null,
            endDate: null,
            uuid: null,
            release: null,
            billCSBs: [],
            billCSBsMap: {},
          },
        }
      };
    },
    computed: {
      billingCategory() {
        return this.form.model.billingConfigItemObject == null ? null : this.form.model.billingConfigItemObject.billingCategory;
      },
      calculateUnit() {
        return this.form.model.billingConfigItemObject == null ? null : this.form.model.billingConfigItemObject.calculateUnit;
      },
      billingCycle() {
        return this.form.model.billingConfigItemObject == null ? null : this.form.model.billingConfigItemObject.billingCycle;
      },
      billingObj() {
        return this.form.model.billingConfigItemObject == null ? null : this.form.model.billingConfigItemObject.billingObj;
      },
      billingContent() {
        return this.form.model.billingConfigItemObject == null ? null : this.form.model.billingConfigItemObject.billingContent;
      },

      oldBillingCategory() {
        return this.form.oldModel.billingConfigItemObject == null ? null : this.form.oldModel.billingConfigItemObject.billingCategory;
      },
      oldCalculateUnit() {
        return this.form.oldModel.billingConfigItemObject == null ? null : this.form.oldModel.billingConfigItemObject.calculateUnit;
      },
      oldBillingCycle() {
        return this.form.oldModel.billingConfigItemObject == null ? null : this.form.oldModel.billingConfigItemObject.billingCycle;
      },
      oldBillingObj() {
        return this.form.oldModel.billingConfigItemObject == null ? null : this.form.oldModel.billingConfigItemObject.billingObj;
      },
      oldBillingContent() {
        return this.form.oldModel.billingConfigItemObject == null ? null : this.form.oldModel.billingConfigItemObject.billingContent;
      },

      isAccum() {
        return this.billingCategory === 'ACCUM';
      },
      isQuota() {
        return this.billingCategory === 'QUOTO';
      },
      isCommit() {
        return this.billingCategory === 'COMMIT';
      },
      isIdle() {
        return this.billingContent === 'IDLE';
      },
      thresholdShow() {
        return this.isAccum && this.isIdle;
      },
      quotaShow() {
        return this.isAccum && this.isIdle || this.isQuota || this.isCommit;
      },
      rateShow() {
        return this.isAccum || this.isQuota || this.isCommit;
      },
      thresholdLabel() {
        return '起征点';
      },
      quotaLabel() {
        return '限额';
      },
      rateLabel() {
        return this.isQuota || this.isCommit ? '超额费用' : '费用';
      },
      formRules(){
        let rules = {};
        rules.billingConfigItemObject = [
          { required: true, message: '请选择计费项', trigger: 'change' },
        ];
        rules.name = [
          { required: true, message: '请填写计费项名称', trigger: 'blur' },
        ];
        rules.power = [
          { 
            required: true, 
            message: '合约功率不能为空', 
            trigger: 'blur' 
          },
          {
            validator: (rule, value, callback) => {
              if (value === undefined || value === null || value === '') {
                return callback();
              }
              // 判断值是否为0
              if (Number(value) === 0) {
                return callback(new Error('合约功率不能为0'));
              }
              callback();
            },
            trigger: 'blur'
          }
        ]
        if (this.thresholdShow) {
          rules.threshold = [
            { required: true, message: `请填写${this.thresholdLabel}`, trigger: 'change' },
          ];
        }
        if (this.quotaShow && !(this.isAccum && this.isIdle)) {
          rules.quota = [
            { required: true, message: `请填写${this.quotaLabel}`, trigger: 'change' },
          ];
        }
        if (this.rateShow) {
          rules.rate = [
            { required: true, message: `请填写${this.rateLabel}`, trigger: 'change' },
          ];
        }
        rules.beginDate = [
          { required: true, message: '请填写开始日期', trigger: 'blur' },
        ];
        rules.endDate = [
          { required: true, message: '请填写结束日期', trigger: 'blur' },
        ];
        return rules;
      },
      editable() {
        return this.operation === 'add' || this.operation === 'edit';
      }
    },
    methods: {
      formatBillCSBs(billCSBs) {
        let column = columnsMap['billCSBs'];
        return column == null || column.format == null ? billCSBs : column.format(billCSBs);
      },
      handleContractConfigItemChange(contractConfigItem) {
        this.form.model.billingConfigItem = contractConfigItem != null ? contractConfigItem.id : null;
      },
      getInitFormModel() {
        return {
          id: null,
          contractId: null,
          billingConfigItem: null,
          name: null,
          threshold: null,
          quota: null,
          ifTest: 0,
          power: null,
          beginDate: null,
          endDate: null,
          uuid: null,
          release: null,
        }
      },
      getOldFormModelShow(key) {
        let cur = this.form.model;
        let old = this.form.oldModel;
        let show;
        let column;
        if (old.uuid == null || cur.uuid == null || this.contractFlag !== 0 || (column = columnsMap[key]) == null) {
          show = false;
        } else {
          show = !columnValueEquals(column, cur, old);
        }
        return show;
      },
      getOldConfigItemShow(key) {
        let cur = this.form.model;
        let old = this.form.oldModel;
        let show;
        show = old.uuid != null && cur.uuid != null && this.contractFlag === 0 && old.billingConfigItemObject != null &&
            cur.billingConfigItemObject != null && old.billingConfigItemObject[key] !== cur.billingConfigItemObject[key];
        return show;
      },
      async loadFormModel({contractId, uuid}) {
        let contractItem = this.form.model;
        let oldContractItem = this.form.oldModel;
        let billCSBs = [];
        if (contractId != null && uuid != null) {
          let responses;
          try {
            responses = await Promise.all([
              BillingServer.contract.getContractItemByContractItemUuid(contractId, uuid),
              BillingServer.contract.getConfirmedContractItem(contractId, uuid),
              getBillCSBs(),
            ]);
          } catch (e) {
            handleError(e);
          }
          billCSBs = responses[2];
          if (responses[0].data.success && responses[1].data.success) {
            contractItem = responses[0].data.data;
            oldContractItem = responses[1].data.data;
            oldContractItem = oldContractItem == null ? this.getInitFormModel() : oldContractItem;
          }
        }
        this.form.model = await this.toModel(contractItem, billCSBs);
        this.form.oldModel = await this.toModel(oldContractItem, billCSBs);
      },
      async toAdd(model) {
        this.operation = 'add';
        this.$refs['form'].resetFields();
        let billCSBs = [];
        try {
          billCSBs = await getBillCSBs();
          model.billCSBs = billCSBs;
          model.billCSBsMap = _.keyBy(model.billCSBs, 'code');
          this.form.model = merge(true, {}, model);
          this.form.oldModel = this.getInitFormModel();
        } catch (e) {
          handleError(e);
        }
      },
      toShow({contractId, uuid}) {
        this.operation = 'show';
        this.$refs['form'].resetFields();
        this.loadFormModel({contractId, uuid});
      },
      toEdit({contractId, uuid}) {
        this.operation = 'edit';
        this.$refs['form'].resetFields();
        this.loadFormModel({contractId, uuid});
      },
      toDelete({contractId, uuid}) {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BillingServer.contract.removeContractItemByContractItemUuid(contractId, uuid, {loading: true}).then((res) => {
            if (res.data.code === 200 || res.data.success) {
              this.emitAfterDelete(uuid);
              this.$message.success('删除成功！');
            } else {
              this.$message.error(`删除失败：${res.data.responseMessage}`);
            }
          }, (error) => {
            handleError(error);
          });
        }, () => {});
      },
      saveAdd() {
        this.$refs['form'].validate(validated => {
          if (validated) {
            let contractId = this.form.model.contractId;
            let data = this.toData(this.form.model);
            BillingServer.contract.addContractItem(contractId, data).then(res => {
              if (res.data.success) {
                this.emitAfterSave(data);
                this.$message.success('保存成功！');
              } else {
                this.$message.error(`保存失败：${res.data.responseMessage}`);
              }
            });
          }
        });
      },
      async saveEdit() {
        let validated = await this.$refs['form'].validate();
        if (validated) {
          let contractId = this.form.model.contractId;
          let contractItemUuid = this.form.model.uuid;
          let data = this.toData(this.form.model);
          BillingServer.contract.modifyContractItemByContractItemUuid(contractId, contractItemUuid, data).then(res => {
            if (res.data.success) {
              this.emitAfterSave(data);
              this.$message.success('保存成功！');
            } else {
              this.$message.error(`保存失败：${res.data.responseMessage}`);
            }
          });
        }
      },
      emitAfterSave(data) {
        this.$emit('after-save', data);
      },
      emitAfterDelete(id) {
        this.$emit('after-delete', id);
      },
      async toModel(data, billCSBs) {
        if (data == null) {
          return data;
        }
        if (data.quota == null) {
          data.quota = undefined;
        }
        if (data.billingConfigItem != null) {
          let billingConfigItemObject;
          let res = await BillingServer.contract.getContractConfigItemByContractConfigItemId(data.billingConfigItem);
          if (res.data.success) {
            billingConfigItemObject = res.data.data;
          }
          data.billingConfigItemObject = billingConfigItemObject;
        }
        setContractItemBillCSBs(data, billCSBs);
        data.billCSBsMap = _.keyBy(data.billCSBs, 'code');
        return data;
      },
      toData(model) {
        model.billingConfigItem = model.billingConfigItemObject != null && model.billingConfigItemObject !== '' ? model.billingConfigItemObject.id : null;
        let attributes;
        if (model.attributes != null && model.attributes !== '') {
          attributes = JSON.parse(model.attributes);
        } else {
          attributes = {};
        }
        attributes.billCSBs = model.billCSBs;
        model.attributes = JSON.stringify(attributes);
        return model;
      }
    },
    filters: {
      formatDate(value, format) {
        return formatDate(value, format);
      }
    }
  }
</script>

<style scoped>
.old-data {
  line-height: 40px;
  color: #e6a23c;
}
</style>
